import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/business-partner/$id/_layout/_index/",
)({
  component: () => null,
});
